<!--
 * @Author: your name
 * @Date: 2022-01-11 18:46:05
 * @LastEditTime: 2022-01-17 19:23:35
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \scp-web\src\views\screenWalls\components\ScreenBox.vue
-->
<template>
  <div
    :class="['ScreenBox', height === '0' ? 'flex' : '']"
    :style="{ height: height}"
  >
    <!-- <el-scrollbar :style="{ height: minHeight + 'px' }"> -->
    <div class="ScreenBox__header">
      <!-- <span class="icon"></div> -->
      <div class="title">
        {{ title }}
      </div>
      <!-- <span class="border"> </span> -->
    </div>
    <div class="ScreenBox__body">
      <slot></slot>
    </div>
    <!-- </el-scrollbar> -->
  </div>
</template>

<script>
export default {
  name: "ScreenBox",
  props: {
    title: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "0",
    },
    // height: {
    //   type: Number,
    //   default: 0,
    // },
  },
};
</script>
<style lang="scss" scoped>
.ScreenBox {
  width: 100%;
  // height: 50%;
  display: flex;
  padding: 10px 30px 10px 30px;
  flex-direction: column;
  // background: url("../assets/img/screenBoxbg.png") no-repeat;
  -moz-background-size: 100% 100%;
  background-size: 100% 100%;

  &.flex {
    flex: 1;
  }

  &__header {
    height: 40px;
    font-size: 18px;
    width: 100%;
    // display: flex;
    color: #ffffff;
    background: url("~@src/common/assets/images/screen/titleLine.png") left bottom no-repeat;

    .title {
      font-family: YouSheBiaoTiHei-Bold;
      font-size: 28px;
      padding: 5px 0 0 0;
      // height: 31px;
      //background: url("~@src/common/assets/images/border.png") left bottom no-repeat;
      // padding-bottom: 14px;
    }
    .border {
      width: 100%;
      display: inline-block;
      flex: 1;
      margin-left: 14px;
      height: 31px;
      //background: url("~@src/common/assets/images/border.png") left bottom no-repeat;
    }
  }

  &__body {
    flex: 1;
    height: 0;
    padding-top: 10px;
  }
}
// .border {
//   width: 100%;
//   display: inline-block;
//   flex: 1;
//   margin-left: 14px;
//   height: 31px;
//   background: url("~@src/common/assets/images/border.png") left bottom no-repeat;
// }
</style>




